import type { Client } from '@urql/core'
import { graphql } from 'app/generated/gql'

import type { CustomPage as CustomPageType, CustomPageListResult } from 'app/generated/graphql'
import { MODEL_FIELDS } from 'app/generated/modelFields'
import { EntityStore } from './EntityStore'

const CUSTOM_PAGE_FIELDS = MODEL_FIELDS.customPage

const LIST_QUERY = graphql(`
  query CustomPages($search: String, $pagination: PaginationInput, $sort: SortInput) {
    customPages(search: $search, pagination: $pagination, sort: $sort) {
      hits {
        id
        orgId
        userId
        name
        page
        join
        filters {
          attribute
          secondaryAttribute
          displayName
          operator
          value
          secondaryValue
          static
          uniqOperator
          readOnly
          nonEmpty
          useAsterisk
          group
          subQuery
          type
          defaultValue
          dateOperator
          includeToday
          includeYesterday
          includeWeeks
          limitToMonth
          includeInThePast
          options
        }
      }
      total
      page
    }
  }
`)

const GET_QUERY = graphql(`
  query CustomPage($id: ID!) {
    customPage(id: $id) {
      id
      orgId
      userId
      name
      page
      join
      filters {
        attribute
        secondaryAttribute
        displayName
        operator
        value
        secondaryValue
        static
        uniqOperator
        readOnly
        nonEmpty
        useAsterisk
        group
        subQuery
        type
        defaultValue
        dateOperator
        includeToday
        includeYesterday
        includeWeeks
        limitToMonth
        includeInThePast
        options
      }
    }
  }
`)

const CREATE_MUTATION = graphql(`
  mutation CreateCustomPage($input: CreateCustomPageInput!) {
    createCustomPage(input: $input) {
      id
      orgId
      userId
      name
      page
      join
      filters {
        attribute
        secondaryAttribute
        displayName
        operator
        value
        secondaryValue
        static
        uniqOperator
        readOnly
        nonEmpty
        useAsterisk
        group
        subQuery
        type
        defaultValue
        dateOperator
        includeToday
        includeYesterday
        includeWeeks
        limitToMonth
        includeInThePast
        options
      }
    }
  }
`)

const UPDATE_MUTATION = graphql(`
  mutation UpdateCustomPage($id: ID!, $input: UpdateCustomPageInput!) {
    updateCustomPage(id: $id, input: $input) {
      id
      orgId
      userId
      name
      page
      join
      filters {
        attribute
        secondaryAttribute
        displayName
        operator
        value
        secondaryValue
        static
        uniqOperator
        readOnly
        nonEmpty
        useAsterisk
        group
        subQuery
        type
        defaultValue
        dateOperator
        includeToday
        includeYesterday
        includeWeeks
        limitToMonth
        includeInThePast
        options
      }
    }
  }
`)

const DELETE_MUTATION = graphql(`
  mutation DeleteCustomPage($id: ID!) {
    deleteCustomPage(id: $id)
  }
`)

export class CustomPageStore extends EntityStore<
  CustomPageType,
  CustomPageListResult,
  typeof CREATE_MUTATION,
  typeof UPDATE_MUTATION
> {
  constructor(client: Client) {
    super(client, {
      listQuery: LIST_QUERY,
      getQuery: GET_QUERY,
      createMutation: CREATE_MUTATION,
      updateMutation: UPDATE_MUTATION,
      deleteMutation: DELETE_MUTATION,
      typename: `CustomPage`,
      extractList: (data: any) => data.customPages,
      extractOne: (data: any) => data.customPage,
      extractMutated: (data: any) => data.createCustomPage ?? data.updateCustomPage,
    })
  }
}
